<template>
<div class="container">
         <div class="row justify-content-center">
            <div class="col-md-5 col-lg-4 my-5">
               <div class="card bg-light bg-gradient shadow-lg rounded-4 animate__animated animate__fadeInDown">
                  <div class="card-body bg-sa-card-body p-2">

                  	<!--<h1 v-if="registeringUser">
               <span>{{progressMessage}}</span> <img :src="`/img/progress.gif`" height="15" />
            </h1>-->


<!-- Heading and alert share one fixed-height slot, so nothing jumps -->
<div class="signup-status">
    <div
        v-if="showAlert"
        :class="['alert', `alert-${alertType}`, 'd-flex', 'align-items-center', 'w-100', 'mb-0']"
        role="alert"
    >
        <span class="flex-grow-1">{{ alertMessage }}</span>
        <button
            type="button"
            class="btn-close ms-auto"
            @click="showAlert = false"
            aria-label="Close"
        ></button>
    </div>

    <h3 v-else class="card-title text-center w-100 mb-0">
        <template v-if="!registeringUser">Sign Up</template>
        <template v-else>
            Registering
            <img src="/img/progress.gif" height="15" class="ms-2" alt="Loading" />
        </template>
    </h3>
</div>
                    
                     <form id="registerForm" autocomplete="off" novalidate @submit.prevent="submitRecord()">
                        <!-- Fake hidden fields to prevent autofill -->
                        <input type="text" name="fakeusernameremembered" style="display:none">
                        <input type="password" name="userpass" style="display:none">
                        <div class="mb-0">
   <label for="company_name" class="form-label">Company Name</label>
   <div class="input-group">
      <span class="input-group-text"><i class="fa fa-building"></i></span>
      <input v-model="formInputs.company_name" @input="handleInputChange" @change="handleInputChange" type="text" class="form-control custom-tooltip-input" id="company_name" placeholder="Enter company name" required autocomplete="organization">
      <div class="custom-tooltip">Please enter your Company Name <span class="tooltip-arrow"></span></div>
   </div>
</div>
                        <div class="mb-0">
                           <label for="full-name" class="form-label">Full Name</label>
                           <div class="input-group">
                              <span class="input-group-text"><i class="fa fa-user"></i></span>
                              <input v-model="formInputs.first_name" @input="handleInputChange" @change="handleInputChange" type="text" class="form-control custom-tooltip-input" id="full-name" placeholder="Enter your Full Name"   required autocomplete="new-email">
                              <div class="custom-tooltip">Please enter your Full Name <span class="tooltip-arrow"></span></div>
                           </div>
                        </div>
                        <div class="mb-0">
                           <label for="email" class="form-label">Email address</label>
                           <div class="input-group">
                              <span class="input-group-text"><i class="fa fa-envelope"></i></span>
                              <input v-model="formInputs.email" @input="handleInputChange" @change="handleInputChange" type="email" class="form-control custom-tooltip-input" id="email" placeholder="Enter email"   required autocomplete="new-email">
                              <div class="custom-tooltip">Please enter your Email <span class="tooltip-arrow"></span></div>
                           </div>
                        </div>
                        <div class="mb-0">
                           <label for="phone" class="form-label">Phone Number</label>
                           <div class="input-group">
                              <span class="input-group-text"><i class="fa fa-phone"></i></span>
                              <input v-model="formInputs.phone" @input="handleInputChange" @change="handleInputChange" type="tel" inputmode="numeric" class="form-control custom-tooltip-input" id="phone" placeholder="e.g. 0712345678" required autocomplete="tel">
                              <div class="custom-tooltip">Please enter your Phone Number <span class="tooltip-arrow"></span></div>
                           </div>
                        </div>
                        <div class="mb-0">
                           <label for="country" class="form-label">Country</label>
                           <div
    class="input-group country-input-group"
    :class="{
        'is-valid':  $isValid('country'),
        'is-invalid': submitted && !$isValid('country')
    }"
>
    <span class="input-group-text">
        <i class="fa fa-globe"></i>
    </span>

    <input
        type="hidden"
        name="country"
        v-model="formInputs.country"
        required
    />

    <v-select
    v-model="formInputs.country"
    @update:modelValue="countryChanged"
    :options="formInputs.countries"
    label="name"
    :reduce="country => country.code"
    placeholder="Select Country"
    class="country-select flex-grow-1 custom-tooltip-input"
    :class="{
        'is-valid': $isValid('country'),
        'is-invalid': submitted && !$isValid('country')
    }"
        :clearable="true"
        :searchable="true"
        required
    >
        <template #option="country">
            <span class="me-2">{{ $getFlag(country.code) }}</span>
            {{ country.name }}
        </template>

        <template #selected-option="country">
            <span class="me-2">{{ $getFlag(country.code) }}</span>
            {{ country.name }}
        </template>
    </v-select>

    <div class="custom-tooltip">
        Please select your Country
        <span class="tooltip-arrow"></span>
    </div>
</div>
                           
                        </div>
                        <div class="mb-0">
                           <label for="password" class="form-label">Password</label>
                           <div class="input-group">
                              <span class="input-group-text"><i class="fa fa-lock"></i></span>
                              <input v-model="formInputs.password" @input="handleInputChange" @change="handleInputChange" :type="showPassword ? 'text' : 'password'" class="form-control custom-tooltip-input" id="password" placeholder="At least 4 characters" minlength="4" required autocomplete="new-password">
                              <div class="custom-tooltip">Password must be at least 4 characters <span class="tooltip-arrow"></span></div>
                           </div>
                        </div>
                        <div class="mb-1">
                           <label for="confirm_password" class="form-label">Confirm Password</label>
                           <div class="input-group">
                              <span class="input-group-text"><i class="fa fa-lock"></i></span>
                              <input v-model="formInputs.confirm_password" @input="handleInputChange" @change="handleInputChange" :type="showPassword ? 'text' : 'password'" class="form-control custom-tooltip-input" :class="{ 'is-invalid': passwordMismatch }" id="confirm_password" placeholder="Repeat your password" required autocomplete="new-password">
                              <div class="custom-tooltip">Please confirm your Password <span class="tooltip-arrow"></span></div>
                           </div>
                           <small v-if="passwordMismatch" class="text-danger">Passwords do not match.</small>
                        </div>
                        <div class="form-check mb-2">
                           <input v-model="showPassword" class="form-check-input" type="checkbox" id="showPassword">
                           <label class="form-check-label" for="showPassword">Show password</label>
                        </div>
                        <div class="d-grid mb-0">
                           <button
   type="submit"
   class="btn btn-primary"
   :disabled="registeringUser"
>
   <template v-if="!registeringUser">
      <i class="fa fa-person-plus me-2"></i>
      Sign Up
   </template>

   <template v-else>
      <span>{{ progressMessage }}</span>
      <img
         src="/img/progress.gif"
         height="15"
         class="ms-2"
         alt="Loading"
      />
   </template>
</button>
                           <span style="color: transparent;">Registering. Please wait...</span>

<button
   v-if="$showSampleButton"
   @click="addSampleData()"
   type="button"
   class="btn btn-info mt-2"
   :disabled="registeringUser"
>
   <i class="fa fa-database me-1"></i> Sample
</button>


                        </div>
                        <div class="text-center mb-0">
                           <span class="sa-core-color">OR</span>
                        </div>
                        <!--<div class="d-flex gap-2">
                           <button type="button" class="btn btn-outline-danger flex-fill">
                           <i class="fa fa-google"></i> Google
                           </button>
                           <button type="button" class="btn btn-outline-primary flex-fill">
                           <i class="fa fa-facebook"></i> Facebook
                           </button>
                        </div>-->                        
                     </form>
                     <p class="text-center text-muted mt-3 small bg-sa-login-reg-text">
                          <!-- Have an account? -->
                           <router-link to="/login">
			                    <a href="#" class="text-decoration-none btn btn-primary d-grid mb-0">
                            Log In                         
                          </a>
			                </router-link>
                        </p>
                  </div>
               </div>
            </div>
         </div>
      </div>
</template>
<script>
   import { computed } from 'vue';
   import axios from 'axios'
   import vSelect from 'vue-select';
   import 'vue-select/dist/vue-select.css';

   import emitter from '../../../main.js'
   //var Emitter = require('tiny-emitter');
   //var emitter = new Emitter();
   
      export default {
         components: {
            vSelect
         },
         data(){
           return {
              submitted: false,
              showPassword: false,
              formInputs: {
                 country: '',
                 countries: this.$getCountries(),
                 company_name: '',
                 first_name: '',
                 email: '',
                 phone: '',
                 password: '',
                 confirm_password: '',
                 currency_code: '',
                 timezone: 'Africa/Nairobi'
              },
              deviceTimezone: 'Africa/Nairobi',
              registeringUser: false,
              showAlert: false,
              alertType: '',
              alertMessage: '',
              progressMessage: 'Registering',
              button_text: 'Verify Code'
           }
         },
         created() {
          this.deviceTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'Africa/Nairobi';
          this.formInputs.timezone = this.deviceTimezone;
         },
         computed: {
           // Show the warning only once something is typed in Confirm Password
           passwordMismatch() {
              return this.formInputs.confirm_password !== '' &&
                 this.formInputs.password !== this.formInputs.confirm_password;
           }
         },
         methods: {
            //submitRecord
             submitRecord(){
              // Ignore Enter or clicks while a registration is already running.
              if (this.registeringUser) return;

              const ready = this.handleBeforeSend();
              if (!ready) {
                 this.$scrollToTop();
                 if (ready === false) this.handleError('Fields cannot be empty');
                 return;
              }
              // Sending: scroll up so the "Registering" heading is visible.
              this.$scrollToTop();

               const formData = new FormData();
               formData.append('company_name', this.formInputs.company_name);
               formData.append('first_name', this.formInputs.first_name);
               formData.append('email', this.formInputs.email);
               formData.append('phone', this.formInputs.phone);
               formData.append('country', this.formInputs.country);
               formData.append('currency_code', this.formInputs.currency_code);
               formData.append('timezone', this.formInputs.timezone);
               formData.append('password', this.formInputs.password);
               formData.append('confirm_password', this.formInputs.confirm_password);
               formData.append('action', 'register'); // Indicating the action for PHP
               axios.post('/auth/api_auth.php', formData, { withCredentials: true })
               .then(response=>{ 
                  if (response.data.status=='success') {
                     this.handleSuccess(response);                     
                  }else {
                     this.handleError(response);                     
                  }
               })
               .catch(error=>{
                  this.handleError('Something went wrong. Please check your connection and try again.');
               })
            },   
            //End submitRecord     
            handleBeforeSend(){
               this.submitted = true;
               const formIsValid = this.$validateForm('#registerForm');
               if (!formIsValid) { return false; }

               if (this.formInputs.password.length < 4) {
                  this.handleError('Password must be at least 4 characters.');
                  return null;
               }

               if (this.formInputs.password !== this.formInputs.confirm_password) {
                  this.handleError('Password and Confirm Password do not match.');
                  return null;
               }

               this.registeringUser = true;
               return true;
            },
            // This method handles the response when the verification is successful
            handleSuccess(response) {
               sessionStorage.setItem('backend_message', response.data.message);

               this.button_text = "";
               this.alertType = 'success';
               this.alertMessage = response.data.message;
               this.showAlert = true;
               this.registeringUser = false;

               // Send verification email using a separate request
               this.sendVerificationEmail(response.data.results.email);
            },
            // This method handles errors that occur during the verification process
            handleError(error) { 
               this.button_text= "";
               this.alertType = 'danger';
               if (error && error.data && error.data.message) {
                  this.alertMessage = error.data.message;
               } else {
                  this.alertMessage = error;
               }
               this.showAlert = true;
               setTimeout(() => { this.showAlert = false;}, 5000);
               this.registeringUser=false;
               this.$router.push('/register');
            },
            sendVerificationEmail(email) {
               const formData = new FormData();

               formData.append('email', email);
               formData.append('action', 'sendVerificationEmail');

               axios.post('/auth/api_auth.php', formData, { withCredentials: true })
                  .then(response => {

                     if (response.data.status === 'success') {

                        console.log('Verification email sent successfully.');

                     } else {

                        console.error(
                           'Verification email failed:',
                           response.data.message
                        );

                     }

                  })
                  .catch(error => {

                     console.error(
                        'Verification email request failed. Please contact admin'
                     );

                  });
            },
            handleInputChange(event) {
               // Call the validation function for the specific input field that triggered the event
               //formValidations(event.target);
               this.$validateField(event.target);
            },
            countryChanged(countryCode) {
               const country = this.formInputs.countries.find(
                  country => country.code === countryCode
               );

               this.formInputs.currency_code = country ? country.currency : '';
               // Timezone follows the selected country (keeps the device one if it's in that country)
               this.formInputs.timezone = countryCode
                  ? this.$getCountryTimezone(countryCode, this.deviceTimezone)
                  : this.deviceTimezone;
               // A country was chosen: move the cursor to Password, so Enter can submit.
                if (countryCode) {
                    this.$nextTick(() => document.querySelector('#password')?.focus());
                }
            },
            addSampleData() {
             const pick = (list) => list[Math.floor(Math.random() * list.length)];

             // One random value so email, phone and company are unique
             const suffix = String(Math.floor(Math.random() * 100000000)).padStart(8, "0");

             const firstNames = ["John", "Brian", "Kevin", "Peter", "David", "Mary", "Faith", "Grace", "Mercy", "Esther"];
             const lastNames = ["Mwangi", "Ochieng", "Kipchoge", "Odhiambo", "Kariuki", "Mutiso", "Wekesa", "Korir", "Njoroge", "Omondi"];
             const companyWords = ["Prime", "Summit", "Bright", "Global", "Unity", "Apex", "Green", "Swift", "Royal", "Nova"];
             const companyTypes = ["Traders", "Enterprises", "Solutions", "Holdings", "Supplies", "Ventures"];

             const firstName = pick(firstNames);
             const lastName = pick(lastNames);

             // Prefer an East African country if it's in the list, otherwise any country
             const preferred = ["KE", "UG", "TZ", "RW"];
             const available = this.formInputs.countries.filter(c => preferred.includes(c.code));
             const country = available.length ? pick(available) : pick(this.formInputs.countries);

             //const password = "Sample@" + suffix.slice(0, 4);
             const password = "admin";

             this.formInputs = {
                ...this.formInputs, // keeps the countries list and timezone
                company_name: `${pick(companyWords)} ${pick(companyTypes)} ${suffix.slice(-4)}`,
                first_name: `${firstName} ${lastName}`,
                email: `${firstName}.${lastName}${suffix}@example.com`.toLowerCase(),
                phone: "07" + suffix,
                country: country ? country.code : "",
                currency_code: country ? country.currency : "",
                timezone: country ? this.$getCountryTimezone(country.code, this.deviceTimezone) : this.deviceTimezone,
                password: password,
                confirm_password: password,
             };

             this.showPassword = true; // so you can see the sample password
             this.submitted = false;
             this.showAlert = false;

             this.$nextTick(() => {
                this.$clearValidationStates('#registerForm');
             });
          },


         }
      };
</script>